export default {
  data() {
    return {
      tables: {
        headers: [
          { text: 'ID', value: 'id', align: 'center', sortable: false },
          { text: 'Статус', value: 'status', align: 'center', sortable: false },
          { text: 'Тип повреждения', value: 'damage_type', align: 'center', sortable: false },
          { text: 'Заключение эксперта', value: 'expert_res', align: 'center', sortable: false },
          { text: 'Номер ФН', value: 'warranty_number', align: 'center', sortable: false },
          { text: 'Дата продажи', value: 'sold_on_local', align: 'center', sortable: false },
          { text: 'Дата создания', value: 'created_at', align: 'center', sortable: false },
          { text: 'Действия', value: 'actions', align: 'center', sortable: false },
        ],
        subHeaders: [
          { text: 'Статус', value: 'status_new', align: 'center', colspan: 2, sortable: false },
          { text: 'Комментарий', value: 'comment', align: 'center', td: 6, sortable: false },
        ],
      },
      filterCreatedAt: null,
      filterSoldOn: null,
      filterWarrantyNumber: null,
      filterId: null,
      filterStatuses: [],
      filterDamagesTypes: [],
      filterExpertReses: [],
      statusesItems: ['Черновик', 'На проверке', 'Отказано', 'Подтверждено', 'На доработке'],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    warranties() {
      return this.$store.state.warranties.warranties;
    },
    pdfFileUrl() {
      return this.$store.state.warranties.pdfFileUrl;
    },

    /** Фильтры */
    types() { return this.$store.state.warranties.types; },
    expertReses() { return this.$store.state.warranties.expertRes; },
    damageTypes() { return this.$store.state.warranties.damageTypes; },
    filteredData() {
      let items = this.warranties;
      if (this.filterCreatedAt) {
        items = items.filter(
          el => el.created_at && el.created_at.includes(this.filterCreatedAt),
        );
      }
      if (this.filterSoldOn) {
        items = items.filter(
          el => el.sold_on_local && el.sold_on_local.includes(this.filterSoldOn),
        );
      }
      if (this.filterWarrantyNumber) {
        items = items.filter(
          el => el.warranty_number && el.warranty_number.includes(this.filterWarrantyNumber),
        );
      }
      if (this.filterId) {
        items = items.filter(el => el.id && el.id.toString().includes(this.filterId));
      }
      if (this.filterStatuses && this.filterStatuses.length) {
        items = items.filter(
          el => el.status_label && this.filterStatuses.includes(el.status_label),
        );
      }
      if (this.filterDamagesTypes && this.filterDamagesTypes.length) {
        items = items.filter(
          el => el.damage_type && this.filterDamagesTypes.includes(el.damage_type),
        );
      }
      if (this.filterExpertReses && this.filterExpertReses.length) {
        items = items.filter(
          el => el.expert_res && this.filterExpertReses.includes(el.expert_res),
        );
      }
      return items;
    },

  },
  methods: {
    GetColumn(status, item) {
      return (status === 'approved') ? item.guarantee.number : item.product.article;
    },
    getSaleQuantity(id) {
      const sale = this.sales.filter(item => item.id === id);
      let quantity = 0;
      if (sale[0].positions) {
        quantity = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.quantity;
          return acc1;
        }, 0);
      }
      return quantity;
    },
    getSaleBonuses(id) {
      const sale = this.sales.filter(item => item.id === id);
      let bonuses = 0;
      if (sale[0].positions) {
        bonuses = sale[0].positions.reduce((acc1, d1) => {
          acc1 += d1.bonuses;
          return acc1;
        }, 0);
      }
      return bonuses;
    },
    changeItem(id) {
      this.$router.push(`/warranty/${id}`);
    },
    showHistory(id) {
      const sale = this.sales.filter(item => item.id === id);
      this.history = sale.length ? sale[0].history : [];
      this.showHistoryID = (this.showHistoryID !== id) ? id : false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'adminReview': return 'color-orange';
        case 'draft': return 'color-white';
        case 'declined': return 'color-red';
        case 'redo': return 'color-red';
        case 'paid': return 'color-green';
        case 'approved': return 'color-green';
        default: return '';
      }
    },
    ShowPhoto(photo) {
      this.showPhoto = true;
      this.currentPhoto = { ...photo };
    },
    ClosePhoto() {
      this.showPhoto = false;
      this.currentPhoto = null;
    },
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
  },
  mounted() {
    this.$store.dispatch('warranties/GetList', { profile_id: this.user.profile_id });
    this.$store.dispatch('warranties/GetInfo');
  },
};
